import RouteLayout, { RouteErrorLayout } from "components/Menu/components/RouteLayout";
import UserGrantItemWorkspace from "components/UserGrants/UserGrantItemWorkspace";
import UserGrantListWorkspace from "components/UserGrants/UserGrantListWorkspace";
import UserGrantWorkspace from "components/UserGrants/UserGrantWorkspace";

export const userGrantRoutes = [
  {
    path: "/userGrant",
    element: <RouteLayout />,
    children: [{ index: true, element: <UserGrantListWorkspace /> }],
    errorElement: <RouteErrorLayout errorTitle="Sharing" />,
  },
  {
    path: "/userGrant/:producer_token",
    element: <RouteLayout />,
    children: [{ index: true, element: <UserGrantWorkspace /> }],
    errorElement: <RouteErrorLayout errorTitle="Sharing" />,
  },
  {
    path: "/userGrant/:producer_token/:user_grant_id",
    element: <RouteLayout />,
    children: [{ index: true, element: <UserGrantItemWorkspace /> }],
    errorElement: <RouteErrorLayout errorTitle="Sharing" />,
  },
];
